import * as React from "react";
import { AsyncActionStatus } from "../../shared/abstractStore";
import { useAsyncCallback } from "react-use-async-callback";
import { useAccountService } from "./useAccountService";

/**
 * Confirm an email address.
 */
export function useConfirmEmailChangeCallback(): [() => Promise<boolean>, AsyncActionStatus] {
    const accountService = useAccountService();

    // Get the return url from the query string.
    const { userId, code, email } = React.useMemo(() => {
        const params = new URLSearchParams(window.location.search);
        const userId = params.get('userId') ?? params.get('UserId') ?? '';
        const code = params.get('code') ?? params.get('Code') ?? '';
        const email = params.get('email') ?? params.get('Email') ?? '';
        return { userId, code, email };
    }, []);

    const [action, { isExecuting, errors }] = useAsyncCallback(async () => {
        return await accountService.confirmEmailChange({ userId: userId, code: code, email: email });
    }, [accountService, userId, code, email]);

    return [action, { isExecuting, errors }];
}
